import { combineReducers } from 'redux';
import { createRouterReducer } from '@lagunovsky/redux-react-router';
import AuthReducer from './AuthReducer';
import TenanReducer from './TenanReducer';

const rootReducer = (history: any) =>
  combineReducers({
    auth: AuthReducer,
    tenant: TenanReducer,
    router: createRouterReducer(history),
  });

export default rootReducer;
